import Tick from "@pqina/flip";

class Events {
	constructor() {
		this.countdown = document.getElementById("countdown");
		this.dateDropdown = document.querySelector(".event-date-dropdown");
		this.events = document.querySelectorAll(".archive-events .event");

		this.init();
	}

	init() {
		if (this.countdown) {
			this.setCountdown();
		}

		if (this.dateDropdown) {
			this.setDateDropdown();
		}

		if (this.events) {
			this.setCookies();
		}
	}

	getCookie(name) {
        const value = `; ${document.cookie}`;
        const parts = value.split(`; ${name}=`);
        if (parts.length === 2) return parts.pop().split(';').shift();
    }

	setCookies() {
		this.events.forEach(event => {
			console.log(event);
            const link = event.querySelector('.event-link');
            link.addEventListener('click', (e) => {
                const eventID = event.dataset.eventid;
                const eventDate = event.dataset.eventdate;
                document.cookie = `selectedEvent-${eventID}=${eventDate}; path=/; max-age=${60 * 60 * 24 * 1}`;
            });
        });
	}

	setCountdown() {
		if (this.countdown) {
			const eventDate = new Date(this.countdown.dataset.date * 1000);
			let tick = Tick.DOM.create(this.countdown, {
				credits: false,
				didInit: (tick) => {
					const counter = Tick.count.down(eventDate, {
						format: ["d", "h", "m", "s"],
					});
					counter.onupdate = (value) => {
						tick.value = value;
					};
				},
			});
		}
	}

	setDateDropdown() {
		const article = document.getElementsByTagName("article")[0];
		const attrID =  article.id;
		const eventID = attrID.replace("post-", "");
        const eventDate = this.getCookie(`selectedEvent-${eventID}`);
        for (let option of this.dateDropdown.querySelector('select').options) {
            if (option.value === eventDate) {
                option.selected = true;
            }
        }
	}
}

export default Events;
